import React from 'react';
import Button from '../index';

const BlueButtonOutlineDark = ({text, isDisabled, isRounded, marginVertical, marginRight, marginTop,onClick}) => {
    return(
        <Button
            variant={'outline-secondary mt-3'}
            text={text}
            disabled={isDisabled}
            rounded={isRounded}
            marginVertical={marginVertical}
            marginRight={marginRight}
            marginTop={marginTop}
            _onClick={onClick}/>
    )
}

export default BlueButtonOutlineDark;